import { NodeModel } from '@minoru/react-dnd-treeview';
import { getChildNodes } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    handlerValidationWorkshiftsSundaysUsuals: (
        startDate: string,
        endDate: string,
        employee: NodeModel[]
    ) => void;
};

export const controllerValidationWorkshiftsSundaysUsualsModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    handlerValidationWorkshiftsSundaysUsuals,
}: Props) => {
    if (startDate && endDate && treeEmployees) {
        handlerValidationWorkshiftsSundaysUsuals(
            startDate,
            endDate,
            getChildNodes(treeEmployees)
        );
    }
};
